import React, { useState } from 'react';
import { IoMail, IoCall, IoLocation, IoTime, IoLogoFacebook, IoLogoInstagram, IoLogoYoutube, IoSend } from 'react-icons/io5';
import Card from '../../components/common/Card/Card';
import Button from '../../components/common/Button/Button';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import { APP_CONFIG } from '../../constants/config';
import './Contact.css';

/**
 * Página de Contacto - Colegio Bertolt Brecht
 */
const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const whatsappMessage = `*Nuevo mensaje de contacto*%0A%0A` +
            `*Nombre:* ${formData.name}%0A` +
            `*Email:* ${formData.email}%0A` +
            `*Teléfono:* ${formData.phone}%0A` +
            `*Asunto:* ${formData.subject}%0A` +
            `*Mensaje:* ${formData.message}`;

        const whatsappNumber = APP_CONFIG.contact.phones[2].replace(/\s/g, '');
        window.open(`https://wa.me/51${whatsappNumber}?text=${whatsappMessage}`, '_blank');
    };

    return (
        <div className="contact">
            {/* Page Header */}
            <PageHeader
                title="Contáctanos"
                subtitle="Estamos aquí para responder todas tus consultas"
            />

            <div className="container">
                <div className="contact__content">
                    {/* Información de Contacto */}
                    <div className="contact__info-section">
                        <h2 className="contact__section-title">Información de Contacto</h2>

                        <div className="contact__info-cards">
                            <Card className="contact__info-card">
                                <div className="contact__info-icon contact__info-icon--primary">
                                    <IoLocation />
                                </div>
                                <h3>Ubicación</h3>
                                <p>{APP_CONFIG.contact.fullAddress}</p>
                            </Card>

                            <Card className="contact__info-card">
                                <div className="contact__info-icon contact__info-icon--secondary">
                                    <IoCall />
                                </div>
                                <h3>Teléfonos</h3>
                                {APP_CONFIG.contact.phones.map((phone, index) => (
                                    <p key={index}>
                                        <a href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a>
                                    </p>
                                ))}
                            </Card>

                            <Card className="contact__info-card">
                                <div className="contact__info-icon contact__info-icon--primary">
                                    <IoMail />
                                </div>
                                <h3>Email</h3>
                                <p>
                                    <a href={`mailto:${APP_CONFIG.contact.email}`}>
                                        {APP_CONFIG.contact.email}
                                    </a>
                                </p>
                            </Card>

                            <Card className="contact__info-card">
                                <div className="contact__info-icon contact__info-icon--secondary">
                                    <IoTime />
                                </div>
                                <h3>Horario de Atención</h3>
                                <p>Lunes - Viernes: 8:00 AM - 4:00 PM</p>
                                <p>Sábados: 9:00 AM - 1:00 PM</p>
                            </Card>
                        </div>

                        {/* Redes Sociales */}
                        <div className="contact__social">
                            <h3>Síguenos en Redes Sociales</h3>
                            <div className="contact__social-links">
                                <a
                                    href={APP_CONFIG.social.facebook}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact__social-link contact__social-link--facebook"
                                >
                                    <IoLogoFacebook />
                                    <span>Facebook</span>
                                </a>
                                <a
                                    href={APP_CONFIG.social.instagram}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact__social-link contact__social-link--instagram"
                                >
                                    <IoLogoInstagram />
                                    <span>Instagram</span>
                                </a>
                                <a
                                    href={APP_CONFIG.social.youtube}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact__social-link contact__social-link--youtube"
                                >
                                    <IoLogoYoutube />
                                    <span>YouTube</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Formulario de Contacto */}
                    <div className="contact__form-section">
                        <Card className="contact__form-card">
                            <h2>Envíanos un Mensaje</h2>
                            <p className="contact__form-description">
                                Completa el formulario y nos pondremos en contacto contigo a la brevedad
                            </p>

                            <form onSubmit={handleSubmit} className="contact__form">
                                <div className="contact__form-group">
                                    <label htmlFor="name">Nombre Completo *</label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        placeholder="Tu nombre"
                                    />
                                </div>

                                <div className="contact__form-row">
                                    <div className="contact__form-group">
                                        <label htmlFor="email">Email *</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            placeholder="tu@email.com"
                                        />
                                    </div>

                                    <div className="contact__form-group">
                                        <label htmlFor="phone">Teléfono *</label>
                                        <input
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            required
                                            placeholder="999 999 999"
                                        />
                                    </div>
                                </div>

                                <div className="contact__form-group">
                                    <label htmlFor="subject">Asunto *</label>
                                    <input
                                        type="text"
                                        id="subject"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                        placeholder="Motivo de tu consulta"
                                    />
                                </div>

                                <div className="contact__form-group">
                                    <label htmlFor="message">Mensaje *</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        rows="5"
                                        placeholder="Escribe tu mensaje aquí..."
                                    ></textarea>
                                </div>

                                <Button type="submit" variant="secondary" size="lg" fullWidth>
                                    <IoSend /> Enviar por WhatsApp
                                </Button>
                            </form>
                        </Card>
                    </div>
                </div>

                {/* Mapa */}
                <section className="contact__map-section">
                    <h2 className="contact__section-title">Nuestra Ubicación</h2>
                    <Card className="contact__map-card">
                        <div className="contact__map-container">
                            <iframe
                                src={APP_CONFIG.contact.mapUrl}
                                width="110%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Ubicación Colegio Bertolt Brecht"
                            ></iframe>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!4v1764354086202!6m8!1m7!1snbM3bSQX1MNujy6Hz28x_g!2m2!1d-13.15927697803276!2d-74.22807703264354!3f230.62423351761961!4f4.681908722427636!5f0.7820865974627469"
                                width="90%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Ubicación Colegio Bertolt Brecht"
                            ></iframe>
                        </div>
                        <div className="contact__map-info">
                            <IoLocation className="contact__map-icon" />
                            <div>
                                <h4>Colegio Bertolt Brecht</h4>
                                <p>{APP_CONFIG.contact.fullAddress}</p>
                            </div>
                        </div>
                    </Card>
                </section>
            </div>
        </div>
    );
};

export default Contact;
